export default function SessionRecovery({retry,checking}) {
  return (
    <div className="flex min-h-[100dvh] items-center justify-center bg-[#0A1628] px-6 text-[#E8EFF7]">
      <div className="max-w-md rounded-xl border border-white/10 bg-[#0F1E36] p-6 text-center">
        <h1 className="text-lg font-semibold">Reconnecting to your account</h1>
        <p className="mt-3 text-sm text-[#9FB2C6]">The server is temporarily unavailable. We’re retrying automatically and keeping your session. You don’t need to keep submitting the login form.</p>
        <button onClick={retry} disabled={checking} className="mt-5 rounded-md bg-[#1678CA] px-4 py-2 text-sm font-medium text-white disabled:opacity-50">{checking ? 'Reconnecting…' : 'Retry now'}</button>
      </div>
    </div>
  );
}
